module.exports = __webpack_public_path__ + "static/media/Chance The Rapper - Acid Rain.bed0933b.mp3";